/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // all_products is limited to 20 per page render; reload sections that exceeded it
  function reloadLookSections() {
    var sections = document.querySelectorAll('.index-look[data-needs-reload]');
    if (!sections.length) return;

    var promises = Array.from(sections).map(function(lookEl) {
      var sectionId = lookEl.getAttribute('data-section-id');
      if (!sectionId) return Promise.resolve();

      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var html = data[sectionId];
          if (!html) return;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          lookEl.querySelectorAll('.look__slide[data-product-handle]').forEach(function(blankSlide) {
            var slideId = blankSlide.getAttribute('data-slide');
            var newSlide = doc.querySelector('.look__slide[data-slide="' + slideId + '"]');
            if (!newSlide) return;
            blankSlide.innerHTML = newSlide.innerHTML;
            blankSlide.removeAttribute('data-product-handle');
          });
        })
        .catch(function(err) {
          console.error('[look-reload] failed for section ' + sectionId, err);
        });
    });

    Promise.all(promises).then(function() {
      if (window.AOS) AOS.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reloadLookSections);
  } else {
    reloadLookSections();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


  /* top-collection
  	$('.top-collection-MENS').addClass('hide-collection');
  	$('.top-collection-WOMENS').addClass('hide-collection');
  	$('.top-collection-UNISEX').addClass('hide-collection');
  
  function collection_mens(){
    console.log('MENS');
  	$('.top-collection-MENS').removeClass('hide-collection');
  	$('.top-collection-WOMENS').addClass('hide-collection');
  	$('.top-collection-UNISEX').addClass('hide-collection');
  };
  function collection_womens(){
    console.log('WOMENS');
  	$('.top-collection-MENS').addClass('hide-collection');
  	$('.top-collection-WOMENS').removeClass('hide-collection');
  	$('.top-collection-UNISEX').addClass('hide-collection');
  };
  function collection_unisex(){
    console.log('UNISEX');
  	$('.top-collection-MENS').addClass('hide-collection');
  	$('.top-collection-WOMENS').addClass('hide-collection');
  	$('.top-collection-UNISEX').removeClass('hide-collection');
  }; */